export default "__VITE_ASSET__C9vhao7S__"